import {
  NATIVE_PUSH_CHANNELS,
  NATIVE_PUSH_DEFAULT_ACTION,
  NATIVE_PUSH_GAME_ID,
  NATIVE_PUSH_TABS,
} from './constants.js';

export const NATIVE_PUSH_CHANNELS_TO_TEXT_MAPPER = {
  [NATIVE_PUSH_CHANNELS.ANDROID]: 'Android',
  [NATIVE_PUSH_CHANNELS.IOS]: 'iOS',
  [NATIVE_PUSH_CHANNELS.ALL]: 'All',
};

export const NATIVE_PUSH_GAME_ID_TO_TEXT_MAPPER = {
  [NATIVE_PUSH_GAME_ID.SB]: 'SB',
};

export const NATIVE_PUSH_CHANNELS_TO_TABS_MAPPER = {
  [NATIVE_PUSH_CHANNELS.IOS]: NATIVE_PUSH_TABS.IOS,
  [NATIVE_PUSH_CHANNELS.ANDROID]: NATIVE_PUSH_TABS.ANDROID,
};

export const NATIVE_PUSH_TABS_TO_TEXT_MAPPER = {
  [NATIVE_PUSH_TABS.IOS]: NATIVE_PUSH_CHANNELS_TO_TEXT_MAPPER[NATIVE_PUSH_CHANNELS.IOS],
  [NATIVE_PUSH_TABS.ANDROID]: NATIVE_PUSH_CHANNELS_TO_TEXT_MAPPER[NATIVE_PUSH_CHANNELS.ANDROID],
};

export const NATIVE_CHANNEL_TO_FORMDATA_MAPPER = {
  [NATIVE_PUSH_CHANNELS.IOS]: 'iosData',
  [NATIVE_PUSH_CHANNELS.ANDROID]: 'androidData',
};

export const NATIVE_PUSH_GAME_ID_TO_MG_CATEGORY_MAPPER = {
  [NATIVE_PUSH_GAME_ID.SB]: 'sb',
};

export const PREVIEW_SECTION_DATA_TO_TEXT_MAPPER = {
  campaignName: 'Campaign Name',
  channel: 'Channel',
  gameId: 'Project',
  messageTitle: 'Message Title',
  messageText: 'Message Text',
  imageUrl: 'Image URL',
  iconUrl: 'Icon URL',
  defaultAction: 'Default Action',
  actionDestination: 'Action Destination',
  startDate: 'Start Date',
  startDateTime: 'Start Time',
  endDate: 'End Date',
  endDateTime: 'End Time',
  retryForNumber: 'Retry For Number',
  retryForPeriod: 'Retry For Period',
  retryUntilDate: 'Retry Until',
  deName: 'Data Extension Name',
  campaignIdManual: 'Campaign ID',
};

export const NATIVE_PUSH_DEFAULT_ACTION_TO_TEXT_MAPPER = {
  [NATIVE_PUSH_DEFAULT_ACTION.NONE]: 'None',
  [NATIVE_PUSH_DEFAULT_ACTION.URL]: 'Open URL',
  [NATIVE_PUSH_DEFAULT_ACTION.DEEPLINK]: 'Go to Deeplink',
};
